<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Opsiyon"
    }
</script>

<style scoped>

</style>